module.exports = "/_next/static/media/27428e95df452bb030d8c4d77afc0fb3.svg";